import React from "react";
import "./index.scss";

function ManageProducts() {
  return <div className="manageProductsPage">Manage products</div>;
}

export default ManageProducts;
